import { Component, NgZone, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { IonRouterOutlet } from "@ionic/angular";
import { fabric } from "fabric";
import { SharedDataService } from "../../services/shared-data.service";
import { UtilService } from "../../services/util.service";
import { ApiService } from 'src/app/services/api.service';

@Component({
  selector: 'app-signature-area',
  templateUrl: './signature-area.component.html',
  styleUrls: ['./signature-area.component.scss'],
})
export class SignatureAreaComponent implements OnInit {

  canvasRef;
  downlaodImg;
  isSignatureFilled = false;
  @Input() currentElementId: string;
  @Output() outputToParent = new EventEmitter<boolean>(false);
  @Output() outputToQuestionParent = new EventEmitter<any>();

  constructor(
    public sharedDataService: SharedDataService,
    private ngZone: NgZone,
    public utilService: UtilService,
    public apiService: ApiService,
    private routerOutlet: IonRouterOutlet
  ) { }

  ngOnInit() {
    this.initialiseDrawing();
  }

  ionViewDidEnter = () => {
    this.routerOutlet.swipeGesture = false;
  };

  ionViewWillLeave = () => {
    this.routerOutlet.swipeGesture = true;
  };

  updateSizeOfSignaturePad = () => {
    const outerCanvasContainer = document.getElementById("canvas-container" + this.currentElementId);

    const ratio = this.canvasRef.getWidth() / this.canvasRef.getHeight();
    const containerWidth = outerCanvasContainer !== null && outerCanvasContainer?.clientWidth;
    const scale = containerWidth / this.canvasRef.getWidth();
    const zoom = this.canvasRef.getZoom() * scale;

    this.canvasRef.setDimensions({
      width: containerWidth,
      height: containerWidth / ratio,
    });
    this.canvasRef.setViewportTransform([zoom, 0, 0, zoom, 0, 0]);
  };

  notificationToParent(selected: boolean) {
    this.outputToParent.emit(selected);
  }

  notificationToParentMultipleData(selected: boolean, id: string) {
    // PNG, deliberately. This was toDataURL("jpeg"), which is not a MIME type, so the
    // browser fell back to PNG anyway while the file was named .jpeg - the server rejected
    // that mismatch and broke dedicated-mode sign-off (CG-1555). Do not switch this to
    // image/jpeg: the canvas has no painted background, only CSS, so its bitmap is
    // transparent and JPEG would render the signature on solid black.
    let downlaodImg = this.canvasRef.toDataURL("image/png");
    let downloadImgName = "digital-signature" + this.currentElementId;
    console.log('type of downlaodImg', typeof (downlaodImg));
    const data = { selected, id, downlaodImg, downloadImgName };
    this.outputToQuestionParent.emit(data);
  }

  initialiseDrawing() {
    setTimeout(() => {
      if (!this.canvasRef) {
        const canvasRef = new fabric.Canvas("digital-signature" + this.currentElementId);
        this.canvasRef = canvasRef;
      }

      let width = 0;
      if (
        this.sharedDataService.dedicatedMode ||
        this.sharedDataService.isTablet ||
        UtilService.isWebApp()
      ) {
        width = (window.innerHeight * 50) / 100;
      } else {
        width = window.innerWidth - 46;
      }
      if (width > 700) {
        width = 700;
      }

      let height = width * 0.48;

      this.canvasRef.setDimensions({
        width: width,
        height: height,
      });

      this.canvasRef.on("selection:created", () => {
        console.log("selection:created");
      });
      this.canvasRef.on("path:created", () => {
        console.log("path:created");
        setTimeout(() => {
          this.notificationToParentMultipleData(this.isSignatureFilled, this.currentElementId)
        }, 100);
        this.ngZone.run(() => {
          this.isSignatureFilled = true;
          // this.downlaodImg = this.canvasRef.toDataURL("jpeg");
          this.notificationToParent(this.isSignatureFilled);
          // this.notificationToParentMultipleData(this.isSignatureFilled, this.currentElementId, this.downlaodImg)
          // try to make get the image in here
          // setTimeout(() => {
          //   let downlaodImg;
          //   downlaodImg = this.canvasRef.toDataURL("jpeg");
          //   console.log('downlaodImg type', typeof(downlaodImg));
          //   console.log('downlaodImg content', downlaodImg);
          //   this.utilService.dataUriToFile(downlaodImg, 'testFileName0103.jpeg', "image/jpeg").then(
          //     (file) => {
          //       console.log('goooood', file);
          //   this.apiService.inFormSignatureUpload(file, 'testFileName0103.jpeg').subscribe((res: Response) => {
          //     console.log('result from new infokoko', res);
          //   })
          //   },
          //   (error) => {
          //     console.log('error in data uri to file');
          //     this.utilService.hideLoading();
          //   }
          //   );
          // }, 1000);
        });
      });
      this.canvasRef.on("selection:cleared", () => { });
      this.canvasRef.freeDrawingBrush.color = "#171538";
      this.canvasRef.freeDrawingBrush.width = 4;
      this.canvasRef.isDrawingMode = true;

      if (UtilService.isWebApp()) {
        window.onresize = this.updateSizeOfSignaturePad;
        this.updateSizeOfSignaturePad();
      }
    }, 200);
  }

}
